import { useEffect, useState } from "react";
import { TERMINAL_LINES } from "../Images/Json/Content";


function Terminal() {
    const [lineIndex, setLineIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);


    useEffect(() => {
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduceMotion) return;

        const current = TERMINAL_LINES[lineIndex];
        const typingSpeed = 90;

        if (charIndex < current.text.length) {
            const t = setTimeout(() => setCharIndex((c) => c + 1), typingSpeed);
            return () => clearTimeout(t);
        }

        const isLastLine = lineIndex === TERMINAL_LINES.length - 1;
        const pause = current.type === "blank" ? 120 : isLastLine ? 2200 : 260;
        const t = setTimeout(() => {
            if (isLastLine) {
                setLineIndex(0);
                setCharIndex(0);
            } else {
                setLineIndex((i) => i + 1);
                setCharIndex(0);
            }
        }, pause);
        return () => clearTimeout(t);
    }, [lineIndex, charIndex]);

    const reduceMotion =
        typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const completedLines = reduceMotion ? TERMINAL_LINES : TERMINAL_LINES.slice(0, lineIndex);
    const current = TERMINAL_LINES[reduceMotion ? TERMINAL_LINES.length - 1 : lineIndex];
    const visibleCurrentText = reduceMotion ? "" : current.text.slice(0, charIndex);

    const renderLine = (line, key, fullText, withCursor) => (
        <div className={`gr-term-line ${line.type}`} key={key}>
            {line.type === "prompt" ? (
                <>
                    <span className="prompt">$ </span>
                    <span className="command">{fullText}</span>
                </>
            ) : (
                <span>{fullText}</span>
            )}
            {withCursor && <span className="gr-term-cursor" />}
        </div>
    );

    return (
        <div className="gr-hero-visual gr-bracket" aria-hidden="true">
            <div className="gr-term-bar">
                <span className="gr-term-dot r" />
                <span className="gr-term-dot y" />
                <span className="gr-term-dot g" />
                <span className="gr-term-title">georgie@deploy — bash</span>
            </div>
            <div className="gr-term-body">
                {completedLines.map((l, i) => renderLine(l, i, l.text, false))}
                {!reduceMotion && renderLine(current, "current", visibleCurrentText, true)}
            </div>
        </div>
    );
}

export default Terminal;